import axios from 'axios';

// 按钮权限
function getBtns(data) {
  return axios.get('platform/v1/resources/granted/button?', { params: data })
}

//  获取数据字典
function getDic(data) {
  return axios.get('agent/v1/signing/interview/term?', {params: data})
}

export default {
  getBtns,
  getDic
};



// WEBPACK FOOTER //
// ./src/interface.js